import { useEffect, useState } from 'react';
import ModalOpcionesImpresion from '../../components/impresion/ModalOpcionesImpresion';
import { clienteService, pagoService, prestamoService } from '../../services/api';
import '../../styles/Reportes.css';

const PagosPorPrestamos = () => {
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState('');
  const [prestamosCliente, setPrestamosCliente] = useState([]);
  const [prestamoId, setPrestamoId] = useState('');
  const [pagos, setPagos] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [prestamo, setPrestamo] = useState(null);
  const [cliente, setCliente] = useState(null);
  const [busquedaCliente, setBusquedaCliente] = useState('');

  // Estados para el modal de impresión
  const [mostrarModalImpresion, setMostrarModalImpresion] = useState(false);
  const [opcionesImpresion, setOpcionesImpresion] = useState(null);

  useEffect(() => {
    cargarClientes();
  }, []);

  const cargarClientes = async () => {
    try {
      const response = await clienteService.getAll();
      setClientes(response.data.clientes || []);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
    }
  };

  const handleClienteChange = async (clienteId) => {
    setClienteSeleccionado(clienteId);
    setPrestamosCliente([]);
    setPrestamoId('');
    setPagos([]);
    setPrestamo(null);
    setCliente(null);

    if (clienteId) {
      try {
        const response = await prestamoService.getAll({ cliente_id: clienteId });
        setPrestamosCliente(response.data.prestamos || []);
      } catch (error) {
        console.error('Error al cargar préstamos:', error);
      }
    }
  };

  const buscarPorPrestamo = async () => {
    if (!prestamoId) {
      alert('Por favor ingresa un ID de préstamo');
      return;
    }

    setCargando(true);
    try {
      const response = await pagoService.getByPrestamo(prestamoId);
      console.log('Respuesta del servidor:', response.data);
      console.log('Pagos recibidos:', response.data.pagos);
      setPagos(response.data.pagos || []);
      setPrestamo(response.data.prestamo);
      setCliente(response.data.cliente);
    } catch (error) {
      alert('Error al cargar los pagos');
      console.error(error);
      setPagos([]);
      setPrestamo(null);
      setCliente(null);
    } finally {
      setCargando(false);
    }
  };

  const clientesFiltrados = clientes.filter(c => {
    if (!busquedaCliente) return true;
    const busqueda = busquedaCliente.toLowerCase();
    return (
      c.cedula?.toLowerCase().includes(busqueda) ||
      c.nombres?.toLowerCase().includes(busqueda) ||
      c.apellidos?.toLowerCase().includes(busqueda) ||
      c.apodo?.toLowerCase().includes(busqueda)
    );
  });

  const formatearFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-DO');
  };

  const calcularTotales = () => {
    const total = pagos.reduce((sum, pago) => sum + pago.monto_total, 0);
    const capital = pagos.reduce((sum, pago) => sum + pago.monto_capital, 0);
    const interes = pagos.reduce((sum, pago) => sum + pago.monto_interes, 0);
    const mora = pagos.reduce((sum, pago) => sum + pago.monto_mora, 0);
    const abono = pagos.reduce((sum, pago) => sum + (pago.monto_abono || 0), 0);

    return { total, capital, interes, mora, abono };
  };

  const totales = calcularTotales();

  const generarPDF = async () => {
    if (!prestamo || pagos.length === 0) {
      alert('Selecciona un préstamo con pagos para generar el PDF');
      return;
    }

    try {
      const token = localStorage.getItem('token');

      // Usar fetch con la URL completa del backend
      const response = await fetch(`window.location.origin/api/documentos/generar-historial-pagos/${prestamo.id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/pdf'
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error del servidor:', errorText);
        throw new Error(`Error al generar PDF: ${response.status}`);
      }

      const blob = await response.blob();

      // Verificar que es realmente un PDF
      if (blob.type !== 'application/pdf') {
        console.error('Tipo de archivo recibido:', blob.type);
        throw new Error('El servidor no devolvió un PDF válido');
      }

      const url = window.URL.createObjectURL(blob);

      // Crear un enlace temporal para descargar
      const a = document.createElement('a');
      a.href = url;
      a.download = `Historial_Pagos_Prestamo_${prestamo.id}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al generar PDF:', error);
      alert('Error al generar el PDF: ' + error.message);
    }
  };

  return (
    <div className="reporte-detalle">
      <div className="reporte-header">
        <h1>💰 Pagos por Préstamos</h1>
        <p>Consulta el historial de pagos de un préstamo específico</p>
      </div>

      <div className="filtros-container">
        <div className="filtro-grupo">
          <label>Buscar Cliente:</label>
          <input
            type="text"
            value={busquedaCliente}
            onChange={(e) => setBusquedaCliente(e.target.value)}
            placeholder="Cédula, nombre o apodo..."
            className="input-text"
            style={{ minWidth: '250px' }}
          />
        </div>

        <div className="filtro-grupo">
          <label>Cliente:</label>
          <select
            value={clienteSeleccionado}
            onChange={(e) => handleClienteChange(e.target.value)}
            className="input-select"
            style={{ minWidth: '300px' }}
          >
            <option value="">--- Seleccione un cliente ---</option>
            {clientesFiltrados.map(cliente => (
              <option key={cliente.id} value={cliente.id}>
                {cliente.cedula} - {cliente.nombres} {cliente.apellidos} {cliente.apodo ? `(${cliente.apodo})` : ''}
              </option>
            ))}
          </select>
        </div>

        {prestamosCliente.length > 0 && (
          <div className="filtro-grupo">
            <label>Préstamo:</label>
            <select
              value={prestamoId}
              onChange={(e) => setPrestamoId(e.target.value)}
              className="input-select"
              style={{ minWidth: '300px' }}
            >
              <option value="">--- Seleccione un préstamo ---</option>
              {prestamosCliente.map(prest => {
                const tienePagos = (prest.cuotas_pagadas || 0) > 0;
                return (
                  <option
                    key={prest.id}
                    value={prest.id}
                    style={{
                      backgroundColor: tienePagos ? '#d4edda' : 'transparent',
                      color: tienePagos ? '#155724' : 'inherit',
                      fontWeight: tienePagos ? 'bold' : 'normal'
                    }}
                  >
                    {tienePagos ? '✓ ' : ''}ID: {prest.id} - {prest.modalidad} - ${prest.total?.toFixed(2)} - {prest.estado}
                  </option>
                );
              })}
            </select>
            <button onClick={buscarPorPrestamo} className="btn-buscar">
              Ver Historial
            </button>
          </div>
        )}

        <div className="separador">O</div>

        <div className="filtro-grupo">
          <label>Préstamo ID directo:</label>
          <input
            type="number"
            value={prestamoId}
            onChange={(e) => setPrestamoId(e.target.value)}
            placeholder="Ingrese el ID del préstamo"
            className="input-text"
            style={{ minWidth: '250px' }}
          />
          <button onClick={buscarPorPrestamo} className="btn-buscar">
            Buscar
          </button>
        </div>
      </div>

      {cliente && prestamo && (
        <div className="info-prestamo">
          <h3>Cliente: {cliente.nombres} {cliente.apellidos}</h3>
          <div className="info-grid">
            <div><strong>Cédula:</strong> {cliente.cedula}</div>
            <div><strong>Préstamo ID:</strong> {prestamo.id}</div>
            <div><strong>Modalidad:</strong> {prestamo.modalidad}</div>
            <div><strong>Tipo:</strong> {prestamo.tipo}</div>
          </div>
        </div>
      )}

      {cargando && (
        <div className="loading">Cargando datos...</div>
      )}

      {!cargando && pagos.length > 0 && (
        <>
          {prestamo && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginBottom: '15px' }}>
              <button
                onClick={() => {
                  // Crear opciones de impresión para este reporte específico
                  setOpcionesImpresion({
                    tipo: 'reporte',
                    reporte_tipo: 'pagos-por-prestamos',
                    opciones: [
                      {
                        id: 'imprimir',
                        nombre: 'IMPRIMIR',
                        icono: '🖨️',
                        descripcion: 'Imprimir historial de pagos',
                        endpoint: `/api/documentos/generar-historial-pagos/${prestamo.id}`,
                        tipo_archivo: 'html'
                      },
                      {
                        id: 'pdf',
                        nombre: 'PDF',
                        icono: '📄',
                        descripcion: 'Descargar PDF del historial',
                        endpoint: `/api/documentos/generar-historial-pagos/${prestamo.id}`,
                        tipo_archivo: 'pdf'
                      },
                      {
                        id: 'whatsapp',
                        nombre: 'WHATSAPP',
                        icono: '💬',
                        descripcion: 'Compartir historial por WhatsApp',
                        endpoint: `/api/impresion/whatsapp/reporte/pagos-prestamos/${prestamo.id}`,
                        tipo_archivo: 'whatsapp'
                      },
                      {
                        id: 'imprimir_whatsapp',
                        nombre: 'IMPRIMIR Y WHATSAPP',
                        icono: '🖨️💬',
                        descripcion: 'Imprimir y compartir por WhatsApp',
                        endpoint: `/api/impresion/combinar/reporte/pagos-prestamos/${prestamo.id}`,
                        tipo_archivo: 'combinar'
                      }
                    ]
                  });
                  setMostrarModalImpresion(true);
                }}
                className="btn-opciones"
                style={{
                  backgroundColor: '#28a745',
                  color: 'white',
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <span>🖨️</span> Opciones de Impresión
              </button>
              <button onClick={generarPDF} className="btn-pdf" style={{
                backgroundColor: '#dc3545',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <span>📄</span> PDF (Directo)
              </button>
            </div>
          )}

          <div className="tabla-container">
            <table className="tabla-reporte">
              <thead>
                <tr>
                  <th>Cuota</th>
                  <th>Monto</th>
                  <th>Capital</th>
                  <th>Interés</th>
                  <th>Mora</th>
                  <th>Abono</th>
                  <th>Fecha</th>
                  <th>Efectividad</th>
                </tr>
              </thead>
              <tbody>
                {pagos.map((pago, index) => (
                  <tr key={pago.id}>
                    <td>{index + 1}</td>
                    <td className="destacado">${pago.monto_total?.toFixed(2)}</td>
                    <td>${pago.monto_capital?.toFixed(2)}</td>
                    <td>${pago.monto_interes?.toFixed(2)}</td>
                    <td>${pago.monto_mora?.toFixed(2)}</td>
                    <td>${(pago.monto_abono || 0).toFixed(2)}</td>
                    <td>{formatearFecha(pago.fecha_pago)}</td>
                    <td>{formatearFecha(pago.fecha_pago)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="totales">
                  <td><strong>Total</strong></td>
                  <td className="destacado"><strong>${totales.total.toFixed(2)}</strong></td>
                  <td><strong>${totales.capital.toFixed(2)}</strong></td>
                  <td><strong>${totales.interes.toFixed(2)}</strong></td>
                  <td><strong>${totales.mora.toFixed(2)}</strong></td>
                  <td><strong>${totales.abono.toFixed(2)}</strong></td>
                  <td colSpan="2"></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="resumen-cards">
            <div className="card-resumen">
              <div className="card-icono">📊</div>
              <div className="card-info">
                <div className="card-valor">{pagos.length}</div>
                <div className="card-label">Pagos Registrados</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">💵</div>
              <div className="card-info">
                <div className="card-valor">${totales.total.toFixed(2)}</div>
                <div className="card-label">Total Cobrado</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">💰</div>
              <div className="card-info">
                <div className="card-valor">${totales.capital.toFixed(2)}</div>
                <div className="card-label">Capital Cobrado</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">📈</div>
              <div className="card-info">
                <div className="card-valor">${totales.interes.toFixed(2)}</div>
                <div className="card-label">Interés Cobrado</div>
              </div>
            </div>
          </div>
        </>
      )}

      {!cargando && pagos.length === 0 && prestamoId && (
        <div className="sin-datos">
          <p>No se encontraron pagos para este préstamo</p>
        </div>
      )}

      {/* Modal de opciones de impresión */}
      <ModalOpcionesImpresion
        isOpen={mostrarModalImpresion}
        onClose={() => {
          setMostrarModalImpresion(false);
          setOpcionesImpresion(null);
        }}
        opciones={opcionesImpresion?.opciones || []}
        titulo="Opciones de Impresión - Historial de Pagos"
        onOpcionSeleccionada={(opcion) => {
          console.log('Opción seleccionada:', opcion.nombre);
          if (opcion.id === 'pdf') {
            // Mantener la funcionalidad existente para PDF directo
            generarPDF();
          }
          setTimeout(() => {
            setMostrarModalImpresion(false);
          }, 1500);
        }}
      />
    </div>
  );
};

export default PagosPorPrestamos;
